import { Component, Input } from '@angular/core';
import { ShipmentTrackerDataDTO } from '@app/core/dto/commons/shipment-tracker.dto';
import { StringUtils } from '@app/core/utils/string.utils';

@Component({
  selector: 'shipment-tracker',
  standalone: true,
  imports: [],
  templateUrl: './shipment-tracker.component.html',
  styleUrl: './shipment-tracker.component.scss',
})
export class ShipmentTrackerComponent {
  @Input() data: ShipmentTrackerDataDTO;
  StringUtils = StringUtils;

  getProgressPercentage(data: any): number {
    if (!data || !data.totalSteps) return 0;
    const completedSteps: number = data.completedSteps;
    const totalSteps: number = data.totalSteps;

    // Calculate percentage based on completed steps
    // For visual progress bar, we want to show progress up to the last completed step
    if (completedSteps === 0) return 0;
    if (completedSteps >= totalSteps) return 100;

    // Calculate the percentage for the progress bar
    // We want to show progress up to the position of the last completed step
    return ((completedSteps - 1) / (totalSteps - 1)) * 100;
  }
}
